import { render, staticRenderFns } from "./PaymentForm.vue?vue&type=template&id=6904b7dc&"
import script from "./PaymentForm.vue?vue&type=script&scoped=true&lang=js&"
export * from "./PaymentForm.vue?vue&type=script&scoped=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports